import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const TabFourteen = ({
  employeeOnboardingData,
  setEmployeeOnboardingData,
  onboardingToDoListData,
  setOnboardingToDoListData,
  isEdit,
  onClickAll
}) => {
  // Add safety check for undefined data
  if (!employeeOnboardingData || !Array.isArray(employeeOnboardingData)) {
    return (
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employee Onboarding
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography>Loading...</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employee Onboarding
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="employee-onboarding-form-all"
            control={
              <Checkbox
                id="employee-onboarding-all"
                checked={employeeOnboardingData.length > 0 && employeeOnboardingData.every((item) => item.value)}
                onClick={(e) =>
                  onClickAll(employeeOnboardingData, 'common', setEmployeeOnboardingData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {employeeOnboardingData.slice().sort((a, b) => a.id - b.id).map((data, index) =>  {
          return (
            <Grid item xs={6} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={employeeOnboardingData[index]?.value || false}
                    onChange={(e) => {
                      let items = [...employeeOnboardingData];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setEmployeeOnboardingData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Onboarding To Do List
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="onboarding-to-do-list-form-all"
            control={
              <Checkbox
                id="onboarding-to-do-list-all"
                disabled={isEdit}
                checked={onboardingToDoListData.length > 0 && onboardingToDoListData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(onboardingToDoListData, 'common', setOnboardingToDoListData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {onboardingToDoListData.slice().sort((a, b) => a.id - b.id).map((data, index) =>  {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={onboardingToDoListData[index]?.value}
                    onChange={(e) => {
                      let items = [...onboardingToDoListData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOnboardingToDoListData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default TabFourteen;